/* VYTA Shop · Kern: Warenkorb über die Shopify Ajax-API, Größen-Finder, Einblendungen.
   Portiert aus dem Website-Prototyp shop-v1.js. Produktseite: vyta-pdp.js */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const R = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const CFG = window.VYTA || {};
  // US-Größe, Innendurchmesser (mm), Umfang (mm) – identisch zum Größen-Finder der Website.
  const SIZES = [[6, 16.5, 51.9], [7, 17.3, 54.4], [8, 18.1, 57.0], [9, 18.9, 59.5], [10, 19.8, 62.1], [11, 20.6, 64.6], [12, 21.4, 67.2], [13, 22.2, 69.7]];
  const eur = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 2 });
  const money = c => eur.format(c / 100);
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const img = (u, w) => u ? u + (u.includes('?') ? '&' : '?') + 'width=' + w : '';

  let cart = null, codeMsg = '';
  async function api(path, body) {
    const res = await fetch(R + path, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'Fehler');
    return data;
  }
  async function refresh() { cart = await api('cart.js'); render(); return cart; }
  const activeCode = () => ((cart && cart.discount_codes) || []).find(c => c.applicable);

  function render() {
    if (!cart) return;
    $$('.cart-btn__count').forEach(el => { el.textContent = cart.item_count; });
    $$('.cart-btn').forEach(el => el.setAttribute('aria-label', 'Warenkorb, ' + cart.item_count + ' Artikel'));
    const body = $('#cart-body'), foot = $('#cart-foot');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="empty"><p>Dein Warenkorb ist noch leer.</p>' + (CFG.ringUrl ? '<a class="btn btn--dark" href="' + CFG.ringUrl + '">VYTA Ring ansehen</a>' : '') + (CFG.bandUrl ? '<a class="link" href="' + CFG.bandUrl + '">oder das VYTA Band</a>' : '') + '</div>';
      foot.hidden = true; return;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map((i, n) => {
      const opts = (i.options_with_values || []).filter(o => o.value !== 'Default Title').map(o => o.value).join(' · ');
      return '<div class="line"><img src="' + esc(img(i.image, 200)) + '" alt="" width="88" height="88" loading="lazy">'
        + '<div><a class="line__name" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a><p class="line__meta">' + esc(opts) + '</p>'
        + '<div class="line__row"><div class="qty"><button type="button" data-q="' + (n + 1) + '" data-d="-1" aria-label="Eins weniger">−</button><output>' + i.quantity + '</output><button type="button" data-q="' + (n + 1) + '" data-d="1" aria-label="Eins mehr">+</button></div>'
        + '<button class="link-btn line__remove" type="button" data-rm="' + (n + 1) + '">Entfernen</button></div></div>'
        + '<p class="line__price">' + (i.original_line_price > i.final_line_price ? '<s>' + money(i.original_line_price) + '</s>' : '') + money(i.final_line_price) + '</p></div>';
    }).join('') + '<p class="fine" style="padding:16px 0">Die kostenlose App ist bei jedem Gerät dabei. AI Coach und VYTA Circle wählst du später in der App.</p>';
    const ac = activeCode(), save = cart.original_total_price - cart.total_price;
    const msg = codeMsg || (ac ? '✓ Gutscheincode aktiv.' : 'Early-Access-Preis ist schon eingerechnet. Gutscheincode? Hier einlösen.');
    foot.innerHTML = '<form class="code" id="code-form" novalidate><label class="visually-hidden" for="code-in">Gutscheincode</label>'
      + '<input id="code-in" placeholder="Gutscheincode" autocomplete="off" value="' + esc(ac ? ac.code : '') + '"><button class="btn btn--outline" type="submit">' + (ac ? 'Ändern' : 'Einlösen') + '</button></form>'
      + '<p class="code-msg ' + (codeMsg ? 'err' : (ac ? 'ok' : '')) + '" id="code-msg">' + esc(msg) + '</p>'
      + '<dl class="sum"><div><dt>Zwischensumme</dt><dd>' + money(cart.original_total_price) + '</dd></div>'
      + (save > 0 ? '<div class="sum__save"><dt>' + 'Rabatt' + '</dt><dd>−' + money(save) + '</dd></div>' : '')
      + '<div><dt>Versand</dt><dd>kostenlos</dd></div><div class="sum__total"><dt>Gesamt</dt><dd>' + money(cart.total_price) + '</dd></div></dl>'
      + '<a class="btn btn--dark btn--block" href="' + R + 'checkout' + (ac ? '?discount=' + encodeURIComponent(ac.code) : '') + '">Sicher zur Kasse <span class="arrow" aria-hidden="true">→</span></a>'
      + '<p class="fine">Bezahlen mit Karte, Apple Pay oder PayPal. Versand kostenlos mit DHL innerhalb Deutschlands. Alle Preise inkl. MwSt.</p>';
  }

  async function changeLine(line, quantity) { try { cart = await api('cart/change.js', { line, quantity }); render(); } catch (e) { refresh(); } }
  async function applyCode(code) {
    codeMsg = '';
    try {
      cart = await api('cart/update.js', { discount: code });
      const hit = (cart.discount_codes || []).find(c => c.code.toUpperCase() === code.toUpperCase());
      if (code && (!hit || !hit.applicable)) { codeMsg = 'Dieser Code ist nicht gültig.'; cart = await api('cart/update.js', { discount: '' }); }
    } catch (e) { codeMsg = 'Der Code konnte gerade nicht geprüft werden. Du kannst ihn auch an der Kasse eingeben.'; }
    render();
  }
  async function addToCart(id, quantity) {
    await api('cart/add.js', { items: [{ id: Number(id), quantity }] });
    await refresh();
    const b = $('.cart-btn'); if (b) { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); }
    openCart();
  }
  function openCart() {
    const d = $('#cart'); if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.classList.add('is-locked');
    setTimeout(() => { const x = $('.x-btn', d); if (x) x.focus(); }, 50);
  }
  function closeCart() {
    const d = $('#cart'); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.classList.remove('is-locked');
  }

  document.addEventListener('click', e => {
    const t = e.target.closest('[data-cart-open],[data-cart-close],[data-q],[data-rm],[data-sizer-open],[data-sizer-close]');
    if (!t) return;
    if (t.matches('[data-cart-open]')) { e.preventDefault(); openCart(); }
    else if (t.matches('[data-cart-close]')) closeCart();
    else if (t.matches('[data-q]')) { const it = cart && cart.items[+t.dataset.q - 1]; if (it) changeLine(+t.dataset.q, Math.max(0, Math.min(9, it.quantity + +t.dataset.d))); }
    else if (t.matches('[data-rm]')) changeLine(+t.dataset.rm, 0);
    else if (t.matches('[data-sizer-open]')) openSizer();
    else if (t.matches('[data-sizer-close]')) $('#sizer').close();
  });
  document.addEventListener('submit', e => { if (e.target.id !== 'code-form') return; e.preventDefault(); applyCode($('#code-in').value.trim().toUpperCase()); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  /* Größen-Finder */
  let sizerTarget = null;
  function nearest(val, col) {
    if (!(val > 0)) return null;
    const lo = SIZES[0][col], hi = SIZES[SIZES.length - 1][col], step = SIZES[1][col] - SIZES[0][col];
    if (val < lo - step / 2 || val > hi + step) return { out: true };
    const hit = SIZES.find(s => s[col] >= val - 0.25) || SIZES[SIZES.length - 1]; // zwischen zwei Größen: die größere
    return { us: hit[0] };
  }
  function openSizer(apply) {
    sizerTarget = apply || null;
    const d = $('#sizer'); if (!d) return;
    $('#sizer-apply').textContent = sizerTarget ? 'Größe übernehmen' : 'Zum Ring mit dieser Größe';
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
  }
  (function bindSizer() {
    const d = $('#sizer'); if (!d) return;
    let current = null;
    $$('[data-tab]', d).forEach(tab => tab.addEventListener('click', () => {
      $$('[data-tab]', d).forEach(x => x.setAttribute('aria-selected', String(x === tab)));
      $$('[data-panel]', d).forEach(p => { p.hidden = p.dataset.panel !== tab.dataset.tab; });
    }));
    $$('[data-in]', d).forEach(inp => inp.addEventListener('input', () => {
      const r = nearest(parseFloat(inp.value.replace(',', '.')), inp.dataset.in === 'string' ? 2 : 1);
      const msg = $('#sizer-msg'), res = $('#sizer-result');
      $$('tr[data-us]', d).forEach(tr => tr.classList.remove('is-hit'));
      current = null;
      if (!r) { res.hidden = true; msg.textContent = ''; return; }
      if (r.out) { res.hidden = true; msg.textContent = 'Dieser Wert liegt außerhalb von US 6 bis 13. Bitte noch einmal messen.'; return; }
      current = r.us; msg.textContent = '';
      $('#sizer-size').textContent = 'US ' + r.us; res.hidden = false;
      const tr = $('tr[data-us="' + r.us + '"]', d); if (tr) tr.classList.add('is-hit');
    }));
    d.addEventListener('click', e => { if (e.target === d) d.close(); });
    $('#sizer-apply').addEventListener('click', () => {
      if (!current) return;
      if (sizerTarget) { sizerTarget(current); d.close(); }
      else if (CFG.ringUrl) location.href = CFG.ringUrl + '?groesse=' + current;
    });
  })();

  /* Startseite: Farbwechsel in Kacheln */
  $$('.tile').forEach(tile => {
    const imgs = $$('.tile__media img', tile), link = $('.tile__link', tile), base = link && link.getAttribute('href').split('?')[0];
    $$('.swatch', tile).forEach(sw => sw.addEventListener('click', () => {
      $$('.swatch', tile).forEach(x => x.setAttribute('aria-pressed', String(x === sw)));
      imgs.forEach(im => im.classList.toggle('is-on', im.dataset.color === sw.dataset.color));
      if (link && sw.dataset.variant) link.setAttribute('href', base + '?variant=' + sw.dataset.variant);
      const lbl = $('.tile__color', tile); if (lbl) lbl.textContent = sw.dataset.color;
    }));
  });

  /* Einblendungen */
  (function bindReveal() {
    let els = $$('[data-reveal]');
    if (window.Shopify && window.Shopify.designMode) { els.forEach(e => e.classList.add('is-in')); return; }
    const upd = () => {
      const limit = window.innerHeight * .92;
      els = els.filter(e => { if (e.getBoundingClientRect().top < limit) { e.classList.add('is-in'); return false; } return true; });
      if (!els.length) window.removeEventListener('scroll', upd);
    };
    window.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
  })();

  window.VYTA_CORE = { $, $$, money, img, addToCart, openSizer };
  refresh().catch(() => {});
  window.addEventListener('pageshow', e => { if (e.persisted) refresh().catch(() => {}); });
})();